import { Component } from "@angular/core";

@Component({
  selector: "app-planning-act-request",
  templateUrl: "./planning-act-request.component.html",
  standalone: false,
})
export class PlanningActRequestComponent {}
